import { useEffect, useState } from "react";
import { Button, IconButton, Menu, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useSnackbar } from "notistack";
import AlertDialog from "elements/AlertDialog";
import ListPagination from "elements/ListPagination";
import { ApiRequest, formatCanadianPrice } from "GlobalFunctions";
import { useNavigate } from "react-router-dom";
import BadgeSubscription from "elements/BadgeSubscription";

export default function Subscriptions(props: any) {
  const { setLoading } = props;
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [list, setList] = useState<any[]>([]);
  const [pagination, setPagination] = useState({ total_pages: 1, total_items: 0 });
  const [page, setPage] = useState(1);
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [activeItem, setActiveItem] = useState<any>(null);
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    setLoading(true);
    loadList();
  }, [page]);

  const loadList = () => {
    setLoading(true);
    ApiRequest({
      method: "GET",
      url: "/subscriptions/list",
      query: { page: page },
      setResponse: (response: any) => {
        console.log("Subscriptions List", response);
        setList(response.list);
        setPagination(response.pagination);
        setLoading(false);
      },
    });
  };

  const handleRowClick = (subscription_id: number) => {
    navigate(`/subscriptions/${subscription_id}`);
  };

  const handleDelete = (event: React.MouseEvent, subscription_id: number) => {
    event.stopPropagation();
    setActiveItem(subscription_id);
    setOpenAlert(true);
  };

  const deleteItem = () => {
    ApiRequest({
      method: "POST",
      url: "/subscriptions/delete",
      body: { subscription_id: activeItem },
      setResponse: (response: any) => {
        if (response.status === "success") {
          enqueueSnackbar("Subscription deleted successfully", { variant: "success" });
          loadList();
        }
      },
    });
    setOpenAlert(false);
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, item: any) => {
    event.stopPropagation();
    setMenuAnchor(event.currentTarget);
    setActiveItem(item);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  return (
    <div className="ModuleContainer">
      <div className="ModuleHeader">
        <div className="ComponentTitle">
          <h1>Subscriptions</h1>
        </div>
        <div className="ModuleActions">

        </div>
      </div>

      <div className="ModuleContent">
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Last Payment</TableCell>
                <TableCell>Next Payment</TableCell>
                <TableCell>Total amount</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Joined On</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((item, i) => (
                <TableRow 
                  key={i}
                  hover
                  onClick={() => handleRowClick(item.subscription_id)}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell>{item.client_name + " "+ item.client_lastname}</TableCell>
                  <TableCell>{item.last_payment_date}</TableCell>
                  <TableCell>{item.next_payment_date}</TableCell>
                  <TableCell>${formatCanadianPrice(item.total_amount)}</TableCell>
                  <TableCell>
                    <BadgeSubscription status_id={item.status_id} />
                  </TableCell>
                  <TableCell>{item.start_date}</TableCell>
                  <TableCell align="right">
                    <IconButton onClick={(event) => handleMenuOpen(event, item)}>
                      <MoreHorizIcon />
                    </IconButton>
                    <Menu
                      anchorEl={menuAnchor}
                      open={Boolean(menuAnchor && activeItem && activeItem.subscription_id === item.subscription_id)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem
                        onClick={(event) => {
                          event.stopPropagation();
                          handleMenuClose();
                          navigate(`/subscriptions/${item.subscription_id}`);
                        }}
                      >
                        <EditIcon fontSize="small" />
                        Edit
                      </MenuItem>
                      <MenuItem onClick={(event) => handleDelete(event, item.subscription_id)}>
                        <DeleteOutlineOutlinedIcon fontSize="small" />
                        Remove
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <ListPagination
          pagination={pagination}
          page={page}
          onChange={(event: any, value: any) => setPage(value)}
          label="Subscriptions"
        />
      </div>

      <AlertDialog
        open={openAlert}
        setOpen={setOpenAlert}
        subtitle="Are you sure you want to delete this subscription?"
        send={deleteItem}
      />
    </div>
  );
}
